import React from 'react'

const LogoCraftwork = ({ style = {}, ...props }) => {
  return (
    <svg
      width="137"
      height="36"
      viewBox="0 0 137 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M49.2042 15.6616C47.5102 15.8596 46.5862 17.3116 46.6082 18.5656C46.6302 20.1936 47.5762 21.5576 49.2702 21.6896C50.4582 21.7776 51.5802 21.0296 51.9542 19.9736L54.8142 20.8096C53.9782 23.2076 51.7782 24.6596 49.1382 24.5496C46.2122 24.4396 43.6602 22.2396 43.6602 18.5436C43.6602 15.3096 46.4762 12.7796 49.2702 12.7576C52.4822 12.7356 54.0882 14.7156 54.7042 16.5636L51.9322 17.3116C51.1182 15.8156 49.9742 15.5736 49.2042 15.6616Z"
        fill="black"
      />
      <path
        d="M58.2226 24.0876L55.3626 24.0656V13.3076H58.2226V14.9136C58.5746 14.0556 59.1026 13.5276 60.1806 13.1316C60.9726 12.8456 62.3146 12.9116 63.0626 13.3516L62.2706 15.9696C61.3906 15.5516 59.9386 15.4856 59.1026 16.4316C58.3546 17.2896 58.2226 17.9276 58.2226 20.7876V24.0876Z"
        fill="black"
      />
      <path
        d="M66.3992 24.4396C67.9832 24.4396 68.9732 23.5376 69.4572 22.8556L69.5452 24.1096H72.4272L72.3612 16.8936C72.3612 15.3536 71.5032 13.9456 69.5012 13.1976C67.9832 12.6256 66.1352 12.8456 65.0132 13.4836C63.4512 14.3636 62.8572 15.5516 62.7032 16.4536L65.2772 17.0036C65.5412 15.5956 66.6412 15.0016 68.0272 15.3536C69.5452 15.7496 69.3032 17.0036 68.9952 17.2456C68.6872 17.4876 67.4112 17.5976 66.3332 17.7516C63.9572 18.0596 62.2852 19.1376 62.5272 21.5356C62.7692 23.3176 64.0672 24.4396 66.3992 24.4396ZM67.6532 22.1296C66.3552 22.3936 65.4092 21.9976 65.4092 20.9416C65.4092 19.4676 67.1472 19.9956 69.5012 19.6216C69.6552 20.7216 69.0612 21.8436 67.6532 22.1296Z"
        fill="black"
      />
      <path
        d="M80.1227 10.7556L80.7607 7.89561C78.3187 7.19161 76.2067 8.22561 75.2827 9.83161C74.9087 10.3816 74.7107 11.2176 74.7107 12.2516C74.7107 12.9996 74.4907 13.1976 73.7867 13.1976H72.9727L72.9947 15.7276H74.7547V24.1096L77.7687 24.0876V15.7276H80.2327L80.2107 13.1976H77.7907C77.7907 11.9216 77.4607 10.3156 80.1227 10.7556Z"
        fill="black"
      />
      <path
        d="M87.6423 23.7796L86.8283 21.2716C86.3663 21.5576 85.4203 21.7336 84.9143 21.1616C84.6063 20.8096 84.5623 20.5016 84.5623 18.9836V15.7716H87.1583V13.2416H84.5843V9.98561H81.7903V12.5156C81.7903 12.9996 81.6363 13.2416 80.9543 13.2416H79.7663V15.7716H81.6583V20.8096C81.6583 22.0636 82.3843 23.8016 84.3643 24.1976C85.9923 24.5276 86.7843 24.1096 87.6423 23.7796Z"
        fill="black"
      />
      <path
        d="M102.548 13.2636H105.628L102.218 24.1316H99.0936L96.8276 16.7836L94.6056 24.1096H91.5036L87.9616 13.2196H91.0416L93.1756 20.2816L95.4416 13.1536H98.3456L100.634 20.3696L102.548 13.2636Z"
        fill="black"
      />
      <path
        d="M105.062 18.6096C105.062 21.7776 107.57 24.4836 110.848 24.4836C114.104 24.4836 116.612 21.7776 116.612 18.6096C116.612 15.4416 114.104 12.8676 110.848 12.8676C107.57 12.8676 105.062 15.4416 105.062 18.6096ZM107.966 18.6316C107.966 16.7836 109.374 15.5296 110.87 15.5296C112.366 15.5296 113.752 16.7836 113.752 18.6316C113.752 20.6116 112.366 21.7776 110.87 21.7776C109.374 21.7776 107.966 20.6116 107.966 18.6316Z"
        fill="black"
      />
      <path
        d="M120.242 24.0876L117.382 24.0656V13.3076H120.242V14.9136C120.594 14.0556 121.122 13.5276 122.2 13.1316C122.992 12.8456 124.334 12.9116 125.082 13.3516L124.29 15.9696C123.41 15.5516 121.958 15.4856 121.122 16.4316C120.374 17.2896 120.242 17.9276 120.242 20.7876V24.0876Z"
        fill="black"
      />
      <path
        d="M132.578 24.1096H136.494L131.566 18.2576L135.9 13.1756H132.358L128.464 17.4436V8.00561H125.406V24.1096H128.442V19.1816L132.578 24.1096Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18ZM18.0835 20.5583C21.4011 15.8667 21.5475 13.0233 18.0835 8C14.5533 13.1305 15.0083 15.8499 18.0835 20.5583ZM16.5081 26.6697C17.0354 20.9478 15.7406 18.4122 10.2289 15.7939C9.737 22.0021 11.4908 24.1297 16.5081 26.6697ZM19.6803 26.6697C19.153 20.9478 20.4479 18.4122 25.9595 15.7939C26.4514 22.0021 24.6977 24.1297 19.6803 26.6697Z"
        fill="black"
      />
    </svg>
  )
}

export default LogoCraftwork
